import { render, staticRenderFns } from "./FaceList.vue?vue&type=template&id=94ab88d4&"
import script from "./FaceList.vue?vue&type=script&lang=js&"
export * from "./FaceList.vue?vue&type=script&lang=js&"
import style0 from "./FaceList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports